import React from 'react';
import { AssignEmployee } from 'domain/shared/core/dashboard';

interface DashboardAssingEmployeeFieldProps {
  assigneeSource?: string;
  entityIdSource?: string;
  employees?: any[];
  callbacks?: any;
  currentUserAlias?: string;
}

const DashboardAssingEmployeeField: React.FC<DashboardAssingEmployeeFieldProps> = ({
  assigneeSource = 'retentionRiskAssigneeAlias',
  entityIdSource = 'retentionRiskId',
  ...props
}) => {
  return <AssignEmployee assigneeSource={assigneeSource} entityIdSource={entityIdSource} {...props} />;
};

export default DashboardAssingEmployeeField;
